/**
 * web/src/screens/Life/tabs.ts — Life's sub-navigation, declared once
 * (card 8hGV3kwDaVoB).
 *
 * The row the Life screen renders and the rows Explore offers are the same
 * list. Keeping it here — a leaf module with no panels, no CSS and no hooks —
 * is what lets MoreMenu import it without dragging the screen in, and what
 * makes "delete a tab and its Explore row goes with it" true by construction
 * rather than by remembering to edit two files.
 */
import type { SubTabDef } from '../../components/SubTabs';

/**
 * Life's sub-navigation (card sjFxIbWi3UgN, Jonathan 2026-10-07): the same
 * top row Notebook carries, so a screen's sections are tabs, not one long
 * stack. Restructured as a consolidated dashboard: Today (the landing tab —
 * what needs you and what is coming up, merged across asks, decisions,
 * household items, sync tasks and dates), Week (the calendar table), Plan
 * (the weekly sync), Household (the working list of shared tasks), Asks &
 * decisions (the rails). Inbox leaves the row — it stays reachable from the
 * More menu and #life-admin, and its unreviewed mail is summarised on Today.
 *
 * Tab keys are unchanged ('chores', 'requests', 'admin', 'plan') so every
 * walk selector, panel id and deep link keeps resolving; only labels and
 * order moved.
 *
 * Naming (founder email 2026-11-04): the catch-all tab is "Requests" — asks
 * and decisions are both requests between the pair — and Inbox is a sub-tab
 * of it rather than a door in the More menu, so all the things that arrive
 * for you sit together.
 */
export const LIFE_TABS: SubTabDef[] = [
  { key: 'today', label: 'Today' },
  { key: 'week', label: 'Week' },
  { key: 'plan', label: 'Plan' },
  { key: 'chores', label: 'Household' },
  { key: 'requests', label: 'Requests' },
  { key: 'admin', label: 'Inbox' },
];
